
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"42","height":"42","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.938 0H9.188a3.817 3.817 0 00-2.785 1.23A4.346 4.346 0 005.25 4.2v33.6c0 1.114.415 2.182 1.153 2.97A3.817 3.817 0 009.188 42h23.624a3.817 3.817 0 002.785-1.23 4.346 4.346 0 001.153-2.97V10.5L24.937 0z","fill":"#FF6B00"}}),_c('path',{attrs:{"d":"M24.938 0v8.5a2 2 0 002 2h9.812","fill":"#FFEBCC"}}),_c('path',{attrs:{"d":"M11.731 29v-6.698h2.907c.735 0 1.302.184 1.7.552.4.367.6.88.6 1.538 0 .66-.2 1.175-.6 1.549-.398.367-.965.551-1.7.551h-1.69V29H11.73zm1.216-3.468h1.501c.874 0 1.311-.38 1.311-1.14 0-.753-.437-1.13-1.31-1.13h-1.502v2.27zM17.691 29v-6.698h.912l3.6 4.675v-4.675h1.131V29h-.902l-3.61-4.693V29h-1.13zM27.78 29.095c-.74 0-1.367-.14-1.88-.418a2.795 2.795 0 01-1.16-1.188c-.265-.512-.398-1.12-.398-1.823 0-.71.136-1.321.408-1.834.273-.52.665-.918 1.178-1.197.513-.285 1.127-.428 1.843-.428.469 0 .909.07 1.32.21.412.132.754.32 1.027.56l-.409.95a2.973 2.973 0 00-.912-.503 3.292 3.292 0 00-1.026-.152c-.71 0-1.248.205-1.615.617-.36.412-.541 1.004-.541 1.777 0 .779.187 1.37.56 1.776.374.405.928.608 1.663.608.209 0 .42-.016.636-.047.222-.038.44-.092.656-.162v-1.558h-1.54v-.902h2.556v3.22c-.31.152-.678.272-1.102.361a6.162 6.162 0 01-1.263.133z","fill":"#fff"}})])
          )
        }
      }
    